import { motion, AnimatePresence } from 'framer-motion';
import './Loader.css';

export default function Loader({ visible }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1] }}
        >
          <motion.span
            className="loader__mark"
            initial={{ opacity: 0, letterSpacing: '0.5em' }}
            animate={{ opacity: 1, letterSpacing: '0.32em' }}
            transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
          >
            SALKARA INN
          </motion.span>
          <motion.div
            className="loader__bar"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.6, ease: [0.19, 1, 0.22, 1] }}
          />
          <span className="loader__caption">Palakkad</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
